module.exports = __webpack_public_path__ + "img/download-white.b0a1c8cc.svg";